import { WaybillIdView } from '../../../../models';

export class ShipmentWaybillTrackingLoad {
  public static readonly type = '[ShipmentWaybillTracking] Load Tracking';
  constructor(public payload: WaybillIdView) {}
}

export class ShipmentWaybillTrackingSetInitialState {
  public static readonly type = '[ShipmentWaybillTracking] Set Initial State';
}
